import { createStyles, Grid, makeStyles, Theme } from '@material-ui/core';
import classNames from 'classnames';
import React from 'react';

import { TnTypography } from '../../TnTypography';
import { HirevueQuestion } from '../types';

interface IProps {
  question: HirevueQuestion;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    answerContainer: {
      flexDirection: 'column',
    },
    optionBox: {
      padding: 8,
      border: '1px solid #808080',
      borderRadius: 4,
      display: 'flex',
      flexDirection: 'row',
      marginTop: 16,
    },
    pointsColumn: {
      width: 48,
    },
    correctAnswer: {
      backgroundColor: 'rgb(71, 209, 71, 0.5)',
    },
    incorrectAnswer: {
      backgroundColor: 'rgb(255, 26, 26, 0.5)',
    },
  }),
);

const MultipleChoice: React.FC<IProps> = ({ question }) => {
  const classes = useStyles();

  const correctAnswerIndex = question.optionPoints?.findIndex((optionPoint) => {
    return optionPoint > 0;
  });

  return (
    <Grid container xs={12} justify="center">
      <Grid className={classes.answerContainer} container justify="center" xs={6}>
        <TnTypography variant="caption">{question.text}</TnTypography>
        {question.options?.map((option: string, index: number) => {
          return (
            <div
              key={option}
              className={classNames({
                [classes.optionBox]: true,
                [classes.correctAnswer]: index === correctAnswerIndex && index === question.selectedOptionIndex,
                [classes.incorrectAnswer]: index !== correctAnswerIndex && index === question.selectedOptionIndex,
              })}
            >
              <div className={classes.pointsColumn}>
                <TnTypography variant="caption2">
                  {question.optionPoints[index] > 0 ? '+' : ''}
                  {question.optionPoints[index]}
                </TnTypography>
              </div>
              <TnTypography variant="caption2">{option}</TnTypography>
            </div>
          );
        })}
      </Grid>
    </Grid>
  );
};

export default MultipleChoice;
